var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGripHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.25C25 17.7969 22.2031 15 18.75 15H11.25C7.79687 15 5 17.7969 5 21.25V28.75C5 32.2031 7.79687 35 11.25 35H18.75C22.2031 35 25 32.2031 25 28.75V21.25ZM25 51.25C25 47.7969 22.2031 45 18.75 45H11.25C7.79687 45 5 47.7969 5 51.25V58.75C5 62.2031 7.79687 65 11.25 65H18.75C22.2031 65 25 62.2031 25 58.75V51.25ZM30 21.25V28.75C30 32.2031 32.7969 35 36.25 35H43.75C47.2031 35 50 32.2031 50 28.75V21.25C50 17.7969 47.2031 15 43.75 15H36.25C32.7969 15 30 17.7969 30 21.25ZM50 51.25C50 47.7969 47.2031 45 43.75 45H36.25C32.7969 45 30 47.7969 30 51.25V58.75C30 62.2031 32.7969 65 36.25 65H43.75C47.2031 65 50 62.2031 50 58.75V51.25ZM55 21.25V28.75C55 32.2031 57.7969 35 61.25 35H68.75C72.2031 35 75 32.2031 75 28.75V21.25C75 17.7969 72.2031 15 68.75 15H61.25C57.7969 15 55 17.7969 55 21.25ZM75 51.25C75 47.7969 72.2031 45 68.75 45H61.25C57.7969 45 55 47.7969 55 51.25V58.75C55 62.2031 57.7969 65 61.25 65H68.75C72.2031 65 75 62.2031 75 58.75V51.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripHorizontal);
export default __webpack_public_path__ + "static/media/grip-horizontal.a6ff393875c74a11841f98bccb467e8c.svg";
export { ForwardRef as ReactComponent };